import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DraggableTable from "../../dargDropTable/dragDropTable";
import itemsServices from "../../../api-services/items-services";
import { useLocation } from "react-router-dom";
import { indexStore } from "../../../store/indexStore";
import { getUniqueCategories } from "../../utils/UtilsFunctions";
import { Combobox } from "src/Components/selectbox/ComboBox";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";
import { ArrowUpDown, FolderTree, Info } from "lucide-react";

function Sort(props) {
  const {
    sortItems,
    nameLang,
    categories,
    getSortItemsFunction,
    itemsLoading,
    restDataSortFunction,
    menus,
  } = indexStore();
  const { t } = useTranslation();
  const [category, setCategory] = useState();

  const location = useLocation();

  useEffect(() => {
    restDataSortFunction();
  }, [restDataSortFunction, location.pathname]);

  const onSelectCategory = (value, option) => {
    setCategory(value);
    getSortItemsFunction(value);
  };
  
  const onMove = (data) => {
    const d = { arr: data };
    itemsServices.sortItems(d);
  };

  const uniqueCategories = getUniqueCategories(categories, menus, nameLang);
  
  return (
    <div className="flex flex-col h-full gap-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
            <ArrowUpDown className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">{t("dashbord.sort")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_sort_desc") || "Drag and drop items to reorder them"}
            </p>
          </div>
        </div>
      </div>

      {/* Filter Card */}
      <Card className="border-2">
        <CardHeader className="pb-3 border-b">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-muted">
              <FolderTree className="w-5 h-5 text-muted-foreground" />
            </div>
            <div>
              <CardTitle className="text-lg">{t("gloabl.select_category") || "Select Category"}</CardTitle>
              <CardDescription>
                {t("gloabl.select_category_sort_desc") || "Choose a category to sort its items"}
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
              <FolderTree className="w-4 h-4" />
              {t("gloabl.category")}
            </label>
            <Combobox
              data={uniqueCategories}
              onChange={onSelectCategory}
              value={category}
              placeholder={t("gloabl.select") + " " + t("gloabl.category")}
              lable={"displayName"}
            />
          </div>
        </CardContent>
      </Card>

      {/* Info Alert */}
      {category && (
        <div className="flex items-start gap-3 p-4 border border-blue-200 bg-blue-50 dark:bg-blue-950/30 dark:border-blue-800 rounded-lg">
          <Info className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <p className="text-sm text-blue-800 dark:text-blue-200">
            {t("gloabl.sort_instructions") || "Drag items using the handle icon to reorder them. Changes are saved automatically."}
          </p>
        </div>
      )}

      {/* Sortable Items */}
      <div className="flex-1">
        {category ? (
          <DraggableTable
            dataSource={sortItems}
            onMove={onMove}
            loading={itemsLoading}
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
            <ArrowUpDown className="w-16 h-16 mb-4 text-gray-300" />
            <p className="text-xl font-semibold mb-2">{t("gloabl.select_category_to_sort") || "Select a category to start sorting"}</p>
            <p className="mb-4">{t("gloabl.select_category_first") || "Please select a category from above to view and sort its items"}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sort;
